import React from "react";
import CustomTextField from "../../../Atoms/TextFields/CustomTextField";
import MDXRichTextEditor from "../../../Atoms/TextFields/MDXRichTextEditor";
import { useSolution } from "../../../../contexts/SolutionsContext";
import IconAndText from "../../../Atoms/IconAndText";
import "../../css/define.solution.css";

const DefineSolution = ({ sno = 1 }) => {
  const { ongoingSolutionData, updateOngoingSolDataL1, validateRequiredField } =
    useSolution();

  const handleNameChange = (e) => {
    const value = e?.target?.value;
    updateOngoingSolDataL1("solution_name", value);
    validateRequiredField("solution_name", value);
  };

  const handlePocChange = (e) => {
    const value = e?.target?.value;
    updateOngoingSolDataL1("point_of_contact", value);
    validateRequiredField("point_of_contact", value);
  };

  // Handle description changes - MDXEditor works directly with markdown
  const handleDescriptionChange = (markdownString) => {
    updateOngoingSolDataL1("description", markdownString);
    validateRequiredField("description", markdownString);
  };

  return (
    <article className="define-solution mb-5">
      <div id="solution-id" className="mb-2">
        <IconAndText
          text="Define Solution"
          clsNames="mas-icon-txt mb-2"
          iconBefore={<div>{sno}</div>}
        />
      </div>

      <section className="d-flex mx-wd-100 gp-x-16">
        <div className="wd-50">
          <label className="mas-form-label-regular">
            {"Solution Name"}
            <span className="marketplace-req-asterik">*</span>
          </label>
          <CustomTextField
            clsNames={"custom-text-field-container"}
            placeholder={"Type name"}
            handleOnChange={handleNameChange}
            value={ongoingSolutionData?.solution_name || ""}
          />
        </div>

        <div className="wd-50">
          <label className="mas-form-label-regular">
            {"Point of Contact"}
            <span className="marketplace-req-asterik">*</span>
          </label>
          <CustomTextField
            clsNames={"custom-text-field-container"}
            placeholder={"Type Name (e.g., Last Name, First Name)"}
            handleOnChange={handlePocChange}
            value={ongoingSolutionData?.point_of_contact || ""}
          />
        </div>
      </section>

      <section className="wd-100 mt-3">
        <label className="mas-form-label-regular">
          {"Solution Description"}
          <span className="marketplace-req-asterik">*</span>
        </label>
        <MDXRichTextEditor
          clsNames="custom-text-field-container"
          placeholder="Enter detailed solution description..."
          value={ongoingSolutionData?.description || ""}
          onChange={handleDescriptionChange}
        />
      </section>
    </article>
  );
};

export default DefineSolution;
